import React from 'react';
import classnames from 'classnames';

import { LazyImg } from '../../hooks/useLazyLoad';

import classes from './Certificates.scss';

type Props = {
    isFooter?: boolean;
    className?: string;
};

export const Certificates: React.FC<Props> = ({ isFooter = false, className }) => (
    <div
        className={classnames(classes.certificates, className, {
            [classes.footer]: isFooter,
        })}
    >
        {!isFooter && (
            <>
                <LazyImg
                    className={classes.isoJoint}
                    src="../../../static/img/isoqar-ukas-joint-logo.png"
                    alt="ISOQAR UKAS certification"
                />
                <LazyImg
                    className={classes.cyber}
                    src="../../../static/img/cyber-essentials.png"
                    alt="Cyber Essentials certification"
                />
            </>
        )}
        {isFooter && (
            <>
                <LazyImg className={classes.ecovadis} src="../../../static/img/bsif.png" alt="BSIF member" />
                <LazyImg
                    className={classes.isoJoint}
                    src="../../../static/img/isoqar-ukas-joint-logo.png"
                    alt="ISOQAR UKAS certification"
                />
                <LazyImg
                    className={classes.cyber}
                    src="../../../static/img/cyber-essentials.png"
                    alt="Cyber Essentials certification"
                />
                <LazyImg className={classes.ecovadis} src="../../../static/img/ecovadis.png" alt="EcoVadis medal" />
                <LazyImg className={classes.rectangleLogo} src="../../../static/img/sedex.png" alt="Sedex member" />
                <LazyImg
                    className={classes.rectangleLogo}
                    src="../../../static/img/disability-confident.png"
                    alt="Disability Confident committed"
                />
                <div className={classes.paymentCards}>
                    <LazyImg className={classes.iso} src="../../../static/img/paypal.png" alt="PayPal" />
                    <LazyImg className={classes.iso} src="../../../static/img/visa.png" alt="Visa" />
                    <LazyImg className={classes.iso} src="../../../static/img/mastercard.png" alt="Mastercard" />
                    <LazyImg className={classes.iso} src="../../../static/img/amex.png" alt="American Express" />
                </div>
            </>
        )}
    </div>
);
